import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ConfirmSaveComponent } from './confirm-save.component';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [ConfirmSaveComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    TranslateModule.forChild()
  ],
  exports: [ConfirmSaveComponent]
})
export class ConfirmSaveModule { }
